import { FC } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';


type Props = ButtonProps

export const BackButton: FC<Props> = ({ sx, onClick, ...props }) => (
  <Button
    startIcon={<ArrowBack/>}
    color="inherit"
    size="small"
    sx={[
      { alignSelf: 'flex-start', textTransform: 'uppercase', letterSpacing: '0.1em' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    onClick={onClick}
    {...props}
  >
    Back
  </Button>
);
